import { render, staticRenderFns } from "./SignUpDialog.vue?vue&type=template&id=14b6735f"
import script from "./SignUpDialog.vue?vue&type=script&lang=js"
export * from "./SignUpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports